/**
 * Created by liuyinghui on 20/9/1.
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const state = {
	webchat: {
		isShowH5: 0,
		accountId: 0,
		language: "zh-CN",
		appId: "",
		appName: "",
		appKey: '',
		domain: '',
		supportMode: 'showConversation',
		userConfig: {
			userTags: 'Portal',
		},
	}
}

const mutations = {
	CHANGELANGUAGE (state, language) {
		state.webchat.language = language;
	},
	CHANGEISSHOWH5 (state, isShowH5) {
		state.webchat.isShowH5 = isShowH5;
	},
	CHANGEAPPID (state, appId) {
		state.webchat.appId = appId;
	},
	CHANGEAPPNAME (state, appName) {
		state.webchat.appName = appName;
	},
	CHANGEACCOUNTID (state, accountId) {
		state.webchat.accountId = accountId;
	}
}

export default new Vuex.Store({
	state,
	mutations,
});